import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
  _pick,
} from "../utils/setting";

const developerAccount = {
  state: {
    listDeveloper: [],
    listDevices: []
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
  },
  effects: (dispatch) => ({
    async create(payload, rootState) {
      let url = DomainAPI + Channel + "/api/secure/developerAccount/create";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    getList(payload, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      const url = `${DomainAPI}${Channel}/api/secure/developerAccount/getList`;

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(_pick(payload, ["limit", "page", "search"])),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code === 1) {
            _this.setState({
              listDeveloper: res.data.list,
              total: res.data.total,
              count: res.data.count,
            });
          }
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    getListDevives(payload, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      const url = `${DomainAPI}${Channel}/api/secure/developerAccount/getListDevives`;

      return fetch(url, {
        method: "GET",
        headers: myHeaders,
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code === 1) {
            _this.setState({
              listDevices: res.data.list,
              totalDevices: res.data.total,
              countDevices: res.data.count,
            });
          }
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async updatedeveloperAccount(payload = {}, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/developerAccount/updatedeveloperAccount";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async deletedeveloperAccount(payload = {}, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/developerAccount/deletedeveloperAccount";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};
export default developerAccount;
